import { Box, Skeleton, Stack } from '@mui/material';

/**
 * Placeholder pour la grille de widgets du tableau de bord (évite layout shift).
 */
export default function DashboardSkeleton({ cards = 6 }) {
  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      gap={2}
      sx={{ width: '100%' }}
      aria-busy="true"
      aria-label="Chargement des indicateurs"
    >
      {Array.from({ length: cards }).map((_, i) => (
        <Box
          key={`dash-sk-${i}`}
          sx={{
            flex: '1 1 240px',
            minWidth: 200,
            maxWidth: { xs: '100%', sm: '48%', md: '31%' },
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2,
            p: 2,
            bgcolor: 'background.paper',
          }}
        >
          <Skeleton variant="text" width="55%" height={22} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="40%" height={36} />
          <Skeleton variant="text" width="70%" height={18} sx={{ mt: 1 }} />
        </Box>
      ))}
    </Stack>
  );
}
